const rootActionPath = 'core/StickyFooterVendor';

export const STICKY_FOOTER_BUTTON_VIEW = `${rootActionPath}/BUTTON/VIEW`;
export const STICKY_FOOTER_EMAIL_VIEW = `${rootActionPath}/EMAIL/VIEW`;
export const STICKY_FOOTER_TOGGLE_TRIGGER = `${rootActionPath}/TOGGLE_TRIGGER`;
